import React from 'react';
import { IS_APPLE } from '../../../../constants/os';
import styles from './ShortcutTooltip.module.scss';

const AppleKeys = [
  { from: 'Ctrl', to: '⌘' },
  { from: 'Alt', to: 'Opt' },
];

interface ShortcutTooltipProps {
  title: string;
  shortcut?: string;
}

const ShortcutTooltip = ({ title, shortcut }: ShortcutTooltipProps) => {
  let normalizedShortcut = shortcut;
  if (normalizedShortcut && IS_APPLE) {
    AppleKeys.forEach(({ from, to }) => {
      normalizedShortcut = normalizedShortcut?.replace(from, to);
    });
  }

  return (
    <div className={styles.container}>
      {title}
      {normalizedShortcut && (
        <div className={styles.shortcut}>{normalizedShortcut}</div>
      )}
    </div>
  );
};

export default ShortcutTooltip;
